<template>
        <v-card color="white" rounded="lg">
        <v-card-text class="pt-8 pl-6 pr-6 pb-4">
            <v-row>
                <v-col cols="12" class="d-flex d-flex justify-start">
                    <h2 class="subtitle is-2">Períodos Contables</h2>
                </v-col>
            </v-row>
            <v-row>
                <v-col v-if="loading || closingJobRunning" cols="12" class="py-0">
                    <v-progress-linear indeterminate color="primary" class="mb-2"></v-progress-linear>
                </v-col>
                <v-col v-if="showClosingJobStatus" cols="12" class="py-0">
                    <div v-if="showClosingJobDismissButton" class="d-flex justify-end mb-2">
                        <v-btn x-small text color="primary" @click="dismissClosingJobStatus">
                            <v-icon small left>mdi-check</v-icon>
                            Ocultar estado
                        </v-btn>
                    </div>
                    <v-alert
                        dense
                        outlined
                        :type="closingJobAlertType"
                        class="mb-0"
                    >
                        <div class="font-weight-medium">Estado del cierre contable</div>
                        <div>{{ closingJobLabel }}</div>
                    </v-alert>
                </v-col>
                <v-col>

                    <GeneralFilter
                        :filterEndpoint="$API.accountingperiod.getAccountingPeriod"
                        :columnsFilterEndpoint="$API.accountingperiod.getAccountingPeriod"
                        :search="search"
                        :show-all-records-toggle="true"
                        @emptyFilter="clearFilter"
                        @loading="loading = $event"
                        @filtered="filterHandler"
                        :advanced-filter="true"
                        :columns.sync="filterColumns"
                        :is-auto-scrolled="true"
                    >
                        <v-col class="text-body-large" cols="12">
                            *Haga click en el <strong>Estado del período</strong> para iniciar el proceso para cerrarlo o reaperturarlo. Al cerrar un período, se calculará el balance de cierre para cada cuenta y se guardará la fecha de cierre. Al reabrir un período cerrado, se eliminarán los balances de cierre y la fecha de cierre, permitiendo realizar ajustes contables si es necesario.
                        </v-col>
                        <DxDataGrid
                            :dataSource="periods"
                            key-expr="id_accounting_period"
                            :scrolling="{ useNative: true }"    
                            :column-auto-width="true"
                            style="max-height: 600px;"
                        >
                            <DxColumn width="70" cell-template="balancesTemplate" caption="" />
                            <DxColumn width="200" data-field="MonthName" caption="Mes" />
                            <DxColumn width="200" data-field="year" caption="Año" />
                            <DxColumn data-field="is_closed" cell-template="statusTemplate" caption="Estado del período" />
                            <DxColumn data-field="closing_date" caption="Fecha de Cierre" />
                        <DxColumn
                            data-field="ClosingBalanceActivosYEgresos"
                            caption="Balance de Cierre - Activos y Egresos"
                            alignment="right"
                            cell-template="closingBalanceMoneyTemplate"
                        />
                        <DxColumn
                            data-field="ClosingBalancePasivosEIngresos"
                            caption="Balance de Cierre - Pasivos e Ingresos"
                            alignment="right"
                            cell-template="closingBalanceMoneyTemplate"
                        />
                        <!-- <DxColumn data-field="ClosingBalancesCountActivosYEgresos" caption="Cuentas de Rubro con Balance - Activos y Egresos" alignment="right" />
                        <DxColumn data-field="ClosingBalancesCountPasivosEIngresos" caption="Cuentas de Rubro con Balance - Pasivos e Ingresos" alignment="right" />-->
                        <DxColumn data-field="LastUpdateUser" caption="Usuario de última Actualización" />
                            <template #statusTemplate="{ data }">
                                <v-chip
                                    :color="data.data.is_closed ? 'red' : 'green'"
                                    :disabled="periodActionsLocked"
                                    :style="{ cursor: periodActionsLocked ? 'not-allowed' : 'pointer' }"
                                    @click.stop="hideClosingJobStatusOnInteraction(); handleStatusClick(data.data)"
                                    dark
                                >
                                    {{ data.data.IsClosedText }}
                                </v-chip>
                            </template>
                            <template #balancesTemplate="{ data }">
                                <v-tooltip bottom>
                                    <template #activator="{ on, attrs }">
                                        <span v-bind="attrs" v-on="on">
                                            <v-btn
                                                icon
                                                small
                                                class="mx-1"
                                                :disabled="Number(data.data.is_closed) !== 1 || periodActionsLocked"
                                                @click.stop="hideClosingJobStatusOnInteraction(); showAccountingBalances(data.data)"
                                            >
                                                <v-icon :color="Number(data.data.is_closed) === 1 && !periodActionsLocked ? 'primary' : 'grey'">mdi-eye</v-icon>
                                            </v-btn>
                                        </span>
                                    </template>
                                    <span>Ver balances</span>
                                </v-tooltip>
                            </template>
                            <template #closingBalanceMoneyTemplate="{ data }">
                                <div class="closing-balance-money-cell">
                                    {{ Currency }}{{ formatMoney(data.value || 0) }}
                                </div>
                            </template>
                        </DxDataGrid>
                    </GeneralFilter>
                </v-col>
            </v-row>
            <v-row>
            </v-row>
        </v-card-text>
        <alert
            v-model="reopenConfirmDialog"
            type="confirm-danger"
            title="Confirmar reapertura de operaciones contables"
            :message="reopenConfirmMessage"
            @action="enterPwdDialog"
        ></alert>
        <alert
            v-model="closeConfirmDialog"
            type="confirm-danger"
            title="Confirmar cierre de operaciones contables"
            :message="closeConfirmMessage"
            @action="closePeriodOperations"
        ></alert>
        <v-dialog v-model="showReopenDialog" max-width="800">
            <v-card>
                <v-card-title class="text-h6">
                    Ingrese a continuación la contraseña de un usuario administrador.
                </v-card-title>
                <v-card-text>
                    <v-col cols="12">
                        <v-text-field
                            v-model="form.pwd"
                            label="Contraseña"
                            outlined
                            type="password"
                            attach
                            dense
                            clearable
                        ></v-text-field>
                    </v-col>
                </v-card-text>
                <v-card-actions class="d-flex justify-space-between">
                    <v-btn
                        class="cancel"
                        @click="() => {
                            showReopenDialog = false;
                            form.pwd = '';
                        }"
                    >
                        Cancelar
                    </v-btn>
                    <v-btn class="btn-save" @click="reopenMonthOperations">
                        Continuar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="showBalancesDialog" max-width="1100" scrollable>
            <v-card>
                <v-card-title class="d-flex justify-space-between align-center flex-wrap">
                    <span class="text-h6">{{ balancesDialogTitle }}</span>
                </v-card-title>
                <v-card-text>
                    <v-row class="mb-4" dense>
                        <v-col
                            v-for="balance in closingBalancesSummary"
                            :key="balance.key"
                            cols="12"
                            md="4"
                            class="py-1"
                        >
                            <v-card outlined class="pa-3">
                                <div class="text-caption grey--text text--darken-1">{{ balance.label }}</div>
                                <div class="closing-balance-money-cell font-weight-medium mt-1">
                                    {{ Currency }}{{ formatMoney(balance.value || 0) }}
                                </div>
                            </v-card>
                        </v-col>
                    </v-row>
                    <v-progress-linear
                        v-if="balancesLoading"
                        indeterminate
                        color="primary"
                        class="mb-4"
                    ></v-progress-linear>
                    <DxDataGrid
                        :dataSource="accountingClosingBalances"
                        key-expr="id_accounting_closing_balance"
                        :scrolling="{ useNative: true }"
                        :grouping="{ autoExpandAll: true }"
                        :group-panel="{ visible: false }"
                        :column-auto-width="false"
                        :show-borders="true"
                        style="max-height: 500px; width: 100%;"
                    >
                        <DxColumn :group-index="0" data-field="source" caption="Tipo" :visible="false" />
                        <DxColumn data-field="id_account" caption="Cuenta" width="15%" />
                        <DxColumn data-field="account_code" caption="Código de cuenta" width="45%" cell-template="accountCodeLeftTemplate" />
                        <DxColumn data-field="balance" caption="Balance" width="30%" alignment="right" cell-template="closingBalanceMoneyTemplate" />
                        <DxColumn data-field="order" caption="Orden" width="10%" />
                        <template #accountCodeLeftTemplate="{ data }">
                            <div class="account-code-left-cell">
                                {{ data.value }}
                            </div>
                        </template>
                        <template #closingBalanceMoneyTemplate="{ data }">
                            <div class="closing-balance-money-cell">
                                {{ Currency }}{{ formatMoney(data.value || 0) }}
                            </div>
                        </template>
                    </DxDataGrid>
                </v-card-text>
                <v-card-actions class="d-flex justify-end flex-wrap">
                    <v-btn
                        v-if="selectedBalancesPeriod && Number(selectedBalancesPeriod.is_closed) === 1"
                        class="btn-save mr-2"
                        :disabled="periodActionsLocked"
                        @click="reopenPeriodFromBalancesDialog"
                    >
                        Reaperturar período
                    </v-btn>
                    <v-btn class="cancel" @click="showBalancesDialog = false">
                        Cerrar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-card>
</template>

<script>
    import {DxDataGrid, DxColumn } from 'devextreme-vue/data-grid';
    import GeneralFilter from '../../../components/GeneralFilter.vue';
    import { formatMoney as formatMoneyHelper } from '@/helpers/money'

    export default {
        name: "AccountingPeriods",
        props: ["win"],
        components: {
            DxDataGrid,
            DxColumn,
            GeneralFilter
        },
        data() {
            return {
                loading: false,
                balancesLoading: false,
                closingJobRunning: false,
                closingJobPollingTimer: null,
                closingJobJobId: null,
                closingJobStatus: null,
                closingJobContext: null,
                closingJobNotificationHidden: false,
                reopenPeriodRunning: false,
                reopenConfirmDialog: false,
                closeConfirmDialog: false,
                showReopenDialog: false,
                showBalancesDialog: false,
                accountingClosingBalances: [],
                closingBalancesSummary: [],
                periodBalance: 0,
                selectedBalancesPeriod: null,
                Currency:  JSON.parse(localStorage.getItem('branch')).Currency || '',
                form: {
                    month: 1,
                    year: new Date().getFullYear(),
                    pwd: ""
                },
                selectedPeriod: null,
                search: {
                    ID_Business: localStorage.getItem("branch").ID_Business,
                    filter: null
                },
                periods: [],
                filterColumns: [
                    {
                        name: "year",
                        title: "Año",
                        value: null,
                        type: "select",
                        options: []
                    },
                    {
                        name: "month",
                        title: "Mes",
                        value: null,
                        type: "dynamic-select",
                        options: [],
                        supplierColumnIndex: 0,
                        disabledMessage: "Seleccione un año primero",
                        enabledMessage: "Meses disponibles según el año contable seleccionado"
                    },
                    {
                        name: "is_closed",
                        title: "Estado del período",
                        value: null,
                        type: "select",
                        options: [
                            { name: "Abierto", value: 0 },
                            { name: "Cerrado", value: 1 }
                        ]
                    },
                    {
                        name: "closing_date",
                        title: "Fecha de Cierre",
                        value: null,
                        type: "date"
                    },
                    {
                        name: "ClosingBalanceActivosYEgresos",
                        title: "Balance de Cierre - Activos y Egresos",
                        value: null,
                        type: "number"
                    },
                    {
                        name: "ClosingBalancePasivosEIngresos",
                        title: "Balance de Cierre - Pasivos e Ingresos",
                        value: null,
                        type: "number"
                    },
                ]
            }
        },
        computed: {
            reopenConfirmMessage() {
                if (!this.selectedPeriod) {
                    return "";
                }

                return `¿Confirma la reapertura de operaciones contables para el período ${this.selectedPeriod.MonthName} ${this.selectedPeriod.year}? Posteriormente se solicitará la contraseña de un usuario administrador.`;
            },
            closeConfirmMessage() {
                if (!this.selectedPeriod) {
                    return "";
                }

                return `¿Confirma el cierre de operaciones contables para el período ${this.selectedPeriod.MonthName} ${this.selectedPeriod.year}?<br><br><strong>Advertencia:</strong> Se guardará una fecha de cierre y se calcularán los balances de cierre para cada cuenta (Esto puede demorar unos minutos).`;
            },
            balancesDialogTitle() {
                if (!this.selectedBalancesPeriod) {
                    return "Balances del período";
                }

                return `Balances del período ${this.selectedBalancesPeriod.MonthName} ${this.selectedBalancesPeriod.year}`;
            },
            showClosingJobStatus() {
                return (this.closingJobRunning || this.closingJobStatus !== null) && !this.closingJobNotificationHidden;
            },
            showClosingJobDismissButton() {
                return this.showClosingJobStatus
                    && this.closingJobStatus
                    && (this.isClosingJobFailed(this.closingJobStatus) || this.isClosingJobCompleted(this.closingJobStatus));
            },
            periodActionsLocked() {
                return this.closingJobRunning || this.reopenPeriodRunning;
            },
            closingJobLabel() {
                if (!this.closingJobStatus) {
                    return this.closingJobRunning ? "Iniciando cierre contable..." : "";
                }

                const message = this.getClosingJobText(this.closingJobStatus.message);
                const phase = this.getClosingJobText(this.closingJobStatus.phase);
                const status = this.getClosingJobText(this.closingJobStatus.status);
                const visiblePhase = phase && !/^\d+$/.test(phase) ? phase : "";
                const visibleStatus = status && !/^\d+$/.test(status) ? status : "";

                if (message && visiblePhase) {
                    return `${message} (${visiblePhase})`;
                }

                if (message) {
                    return message;
                }

                if (visiblePhase) {
                    return visiblePhase;
                }

                if (visibleStatus) {
                    return visibleStatus;
                }

                if (this.isClosingJobCompleted(this.closingJobStatus)) {
                    return "El cierre contable se completó correctamente.";
                }

                if (this.isClosingJobFailed(this.closingJobStatus)) {
                    return "El cierre contable presentó un error.";
                }

                return this.closingJobRunning ? "Procesando cierre contable..." : "";
            },
            closingJobAlertType() {
                if (!this.closingJobStatus) {
                    return "info";
                }

                if (this.isClosingJobFailed(this.closingJobStatus)) {
                    return "error";
                }

                if (this.isClosingJobCompleted(this.closingJobStatus)) {
                    return "success";
                }

                return "info";
            }
        },
        mounted() {
            this.fetchAllPeriods();
        },
        beforeDestroy() {
            this.clearClosingJobPolling();
        },
        methods: {
            formatMoney( value ) {
                return formatMoneyHelper( value );
            },
            async fetchAllPeriods() {
                this.hideClosingJobStatusOnInteraction();
                this.loading = true;

                try {
                    const { result } = await this.$API.accountingperiod.getAccountingPeriod();

                    if (result) {
                        this.periods = result;

                        const uniqueYears = [...new Set(result.map(period => period.year))];
                        const uniqueMonths = [...new Set(result.map(period => ({ id: period.year, option: { name: period.MonthName, value: period.month } })))];

                        const sortedYears = uniqueYears.sort((a, b) => {
                            return a.year - b.year; // Ordenar por año
                        });

                        const sortedMonths = uniqueMonths.sort((a, b) => {
                            if(a.id !== b.id) {
                                return a.id - b.id; // Ordenar por año primero
                            }
                            return a.option.value - b.option.value; // Ordenar por número de mes
                        });

                        // Populate month options for the filter
                        const monthColumnIndex = this.filterColumns.findIndex(col => col.name === "month");

                        this.filterColumns[monthColumnIndex].options = sortedMonths;

                        // Populate year options for the filter
                        const yearColumnIndex = this.filterColumns.findIndex(col => col.name === "year");
                        const yearOptions = [...new Set(sortedYears.map(year => ({ name: year, value: year })))];
                        this.filterColumns[yearColumnIndex].options = yearOptions;
                    } else {
                        this.$toast.error("Error al cargar los períodos contables.");
                    }
                } catch (error) {
                    this.$toast.error("Error al cargar los períodos contables.");
                } finally {
                    this.loading = false;
                }
            },
            clearFilter() {
                this.fetchAllPeriods();
            },
            normalizeClosingBalanceSource(balance = {}) {
                const source = balance.source || balance.Source || balance.SOURCE || balance.source_name || balance.SourceName || balance.sourceLabel || balance.SourceLabel;

                return this.getClosingJobText(source) || "Sin fuente";
            },
            getClosingBalanceSummaryValue(source = {}, fallbackSource = {}, fieldName = "") {
                if (source && source[fieldName] !== undefined && source[fieldName] !== null && source[fieldName] !== "") {
                    return source[fieldName];
                }

                if (fallbackSource && fallbackSource[fieldName] !== undefined && fallbackSource[fieldName] !== null && fallbackSource[fieldName] !== "") {
                    return fallbackSource[fieldName];
                }

                return 0;
            },
            buildClosingBalancesSummary(source = {}, fallbackSource = {}) {
                return [
                    {
                        key: "closing-balance-activos-egresos",
                        label: "Balance de Cierre - Activos y Egresos",
                        value: this.getClosingBalanceSummaryValue(source, fallbackSource, "ClosingBalanceActivosYEgresos")
                    },
                    {
                        key: "closing-balance-pasivos-ingresos",
                        label: "Balance de Cierre - Pasivos e Ingresos",
                        value: this.getClosingBalanceSummaryValue(source, fallbackSource, "ClosingBalancePasivosEIngresos")
                    }
                ];
            },
            getClosingJobText(value) {
                if (value === null || value === undefined) {
                    return "";
                }

                return String(value).trim();
            },
            getClosingJobValue(response, fieldNames, fallback = null) {
                const sources = [];

                if (response && response.result) {
                    sources.push(response.result);
                }

                if (response && response.data) {
                    sources.push(response.data);
                }

                if (response) {
                    sources.push(response);
                }

                for (let i = 0; i < sources.length; i += 1) {
                    const source = sources[i];

                    if (!source) {
                        continue;
                    }

                    for (let j = 0; j < fieldNames.length; j += 1) {
                        const fieldName = fieldNames[j];
                        const value = source[fieldName];

                        if (value !== undefined && value !== null && value !== "") {
                            return value;
                        }
                    }
                }

                return fallback;
            },
            normalizeClosingJobState(response = {}, fallbackJobId = null) {
                return {
                    jobId: this.getClosingJobValue(response, ["jobId", "job_id", "jobID"], fallbackJobId),
                    success: this.getClosingJobValue(response, ["success"], null),
                    status: this.getClosingJobValue(response, ["status"], null),
                    phase: this.getClosingJobValue(response, ["phase"], null),
                    message: this.getClosingJobValue(response, ["message"], ""),
                    summary: this.getClosingJobValue(response, ["summary"], null),
                    completedAt: this.getClosingJobValue(response, ["completedAt", "completed_at"], null)
                };
            },
            isClosingJobFailed(job = {}) {
                if (job.success === false) {
                    return true;
                }

                const status = this.getClosingJobText(job.status).toUpperCase();
                const phase = this.getClosingJobText(job.phase).toUpperCase();
                const failureTokens = ["FAILED", "FAIL", "ERROR", "CANCELLED", "CANCELED", "ABORTED"];

                return failureTokens.some((token) => status.indexOf(token) !== -1 || phase.indexOf(token) !== -1);
            },
            isClosingJobCompleted(job = {}) {
                if (this.isClosingJobFailed(job)) {
                    return false;
                }

                if (job.completedAt) {
                    return true;
                }

                const status = this.getClosingJobText(job.status).toUpperCase();
                const phase = this.getClosingJobText(job.phase).toUpperCase();
                const successTokens = ["COMPLETED", "COMPLETE", "SUCCESS", "SUCCEEDED", "DONE", "FINISHED"];

                return successTokens.some((token) => status.indexOf(token) !== -1 || phase.indexOf(token) !== -1);
            },
            clearClosingJobPolling() {
                if (this.closingJobPollingTimer) {
                    clearTimeout(this.closingJobPollingTimer);
                    this.closingJobPollingTimer = null;
                }
            },
            scheduleClosingJobPoll() {
                this.clearClosingJobPolling();
                this.closingJobPollingTimer = setTimeout(() => {
                    this.pollClosingJobStatus();
                }, 5000);
            },
            clearClosingJobTracking() {
                this.clearClosingJobPolling();
                this.closingJobRunning = false;
                this.closingJobJobId = null;
                this.closingJobStatus = null;
                this.closingJobContext = null;
            },
            finishClosingJobTracking() {
                this.clearClosingJobPolling();
                this.closingJobRunning = false;
            },
            prepareClosingJobTracking() {
                this.clearClosingJobTracking();
                this.closingJobContext = {
                    month: this.form.month,
                    year: this.form.year,
                    periodSnapshot: this.selectedPeriod ? { ...this.selectedPeriod } : null
                };
                this.closingJobStatus = {
                    jobId: null,
                    success: null,
                    status: "PENDING",
                    phase: "INICIANDO",
                    message: "Iniciando cierre contable...",
                    summary: null,
                    completedAt: null
                };
                this.closingJobNotificationHidden = false;
                this.closingJobRunning = true;
            },
            dismissClosingJobStatus() {
                this.closingJobNotificationHidden = true;
            },
            hideClosingJobStatusOnInteraction() {
                if (this.closingJobStatus && !this.closingJobRunning) {
                    this.closingJobNotificationHidden = true;
                }
            },
            getClosingJobErrorMessage(error, fallbackMessage = "Hubo un problema al consultar el estado del cierre contable.") {
                if (!error) {
                    return fallbackMessage;
                }

                if (typeof error === "string") {
                    return error;
                }

                if (error.message) {
                    return error.message;
                }

                if (error.response && error.response.data && error.response.data.message) {
                    return error.response.data.message;
                }

                if (error.data && error.data.message) {
                    return error.data.message;
                }

                return fallbackMessage;
            },
            applyClosedPeriodUpdate(updatedPeriod = null) {
                const context = this.closingJobContext || {};
                const month = Number(context.month !== undefined && context.month !== null ? context.month : this.form.month);
                const year = Number(context.year !== undefined && context.year !== null ? context.year : this.form.year);
                const fallbackPeriod = updatedPeriod || context.periodSnapshot || this.selectedPeriod || null;

                this.periods = this.periods.map((period) => {
                    if (Number(period.month) !== month || Number(period.year) !== year) {
                        return period;
                    }

                    if (updatedPeriod) {
                        return {
                            ...period,
                            ...updatedPeriod,
                            is_closed: 1,
                            IsClosedText: "Cerrado"
                        };
                    }

                    if (fallbackPeriod) {
                        return {
                            ...period,
                            ...fallbackPeriod,
                            is_closed: 1,
                            IsClosedText: "Cerrado"
                        };
                    }

                    return {
                        ...period,
                        is_closed: 1,
                        IsClosedText: "Cerrado"
                    };
                });

                if (this.selectedPeriod && Number(this.selectedPeriod.month) === month && Number(this.selectedPeriod.year) === year) {
                    const basePeriod = updatedPeriod || context.periodSnapshot || this.selectedPeriod;

                    this.selectedPeriod = {
                        ...this.selectedPeriod,
                        ...basePeriod,
                        is_closed: 1,
                        IsClosedText: "Cerrado"
                    };
                }
            },
            async refreshClosedPeriodAfterCompletion() {
                const context = this.closingJobContext || {};

                this.loading = true;

                try {
                    const { result } = await this.$API.accountingperiod.getAccountingPeriod({
                        month: context.month !== undefined && context.month !== null ? context.month : this.form.month,
                        year: context.year !== undefined && context.year !== null ? context.year : this.form.year,
                        is_closed: 1
                    });

                    const updatedPeriod = Array.isArray(result) ? result[0] : result;

                    this.applyClosedPeriodUpdate(updatedPeriod);
                } catch (error) {
                    this.applyClosedPeriodUpdate(null);
                } finally {
                    this.loading = false;
                }
            },
            async pollClosingJobStatus() {
                if (!this.closingJobJobId) {
                    this.finishClosingJobTracking();
                    return;
                }

                try {
                    const response = await this.$API.accountingperiod.getClosingBalanceJobStatus(this.closingJobJobId);
                    const normalizedState = this.normalizeClosingJobState(response, this.closingJobJobId);

                    this.closingJobStatus = {
                        ...this.closingJobStatus,
                        ...normalizedState
                    };
                    this.closingJobJobId = this.closingJobStatus.jobId || this.closingJobJobId;

                    if (this.isClosingJobFailed(this.closingJobStatus)) {
                        this.finishClosingJobTracking();
                        this.$toasted.error(this.getClosingJobErrorMessage(this.closingJobStatus, "El cierre contable no pudo completarse."));
                        return;
                    }

                    if (this.isClosingJobCompleted(this.closingJobStatus)) {
                        this.clearClosingJobPolling();
                        await this.refreshClosedPeriodAfterCompletion();
                        this.finishClosingJobTracking();
                        this.$toasted.success(this.closingJobStatus.message || "Se cerraron las operaciones del período seleccionado.");
                        return;
                    }

                    this.scheduleClosingJobPoll();
                } catch (error) {
                    this.closingJobStatus = {
                        ...this.closingJobStatus,
                        status: "FAILED",
                        phase: "ERROR",
                        message: this.getClosingJobErrorMessage(error, "No fue posible consultar el estado del cierre contable."),
                        completedAt: new Date().toISOString()
                    };
                    this.finishClosingJobTracking();
                    this.$toasted.error(this.getClosingJobErrorMessage(this.closingJobStatus, "No fue posible consultar el estado del cierre contable."));
                }
            },
            handleStatusClick(period) {
                if (this.periodActionsLocked) {
                    return;
                }

                this.hideClosingJobStatusOnInteraction();
                this.selectedPeriod = period;
                this.form.month = period.month;
                this.form.year = period.year;
                this.reopenConfirmDialog = false;
                this.closeConfirmDialog = false;
                this.showReopenDialog = false;

                if (Number(period.is_closed) === 1) {
                    this.form.pwd = "";
                    this.reopenConfirmDialog = true;
                    return;
                }

                this.closeConfirmDialog = true;
            },
            enterPwdDialog() {
                this.reopenConfirmDialog = false;
                this.showReopenDialog = true;
            },
            async showAccountingBalances(period) {
                if (this.periodActionsLocked || Number(period.is_closed) !== 1) {
                    return;
                }

                this.selectedBalancesPeriod = period;
                this.accountingClosingBalances = [];
                this.closingBalancesSummary = this.buildClosingBalancesSummary({}, period);
                this.periodBalance = 0;
                this.showBalancesDialog = true;
                this.balancesLoading = true;

                try {
                    const { result } = await this.$API.accountingperiod.getBalances(period.id_accounting_period);
                    const balancesPayload = result || {};
                    const accountingClosingBalances = Array.isArray(balancesPayload.accountingClosingBalances) ? balancesPayload.accountingClosingBalances : [];

                    this.accountingClosingBalances = accountingClosingBalances.map((balance) => ({
                        ...balance,
                        source: this.normalizeClosingBalanceSource(balance)
                    }));
                    this.closingBalancesSummary = this.buildClosingBalancesSummary(balancesPayload, period);
                    this.periodBalance = balancesPayload && balancesPayload.periodBalance !== undefined && balancesPayload.periodBalance !== null ? balancesPayload.periodBalance : 0;
                } catch (error) {
                    this.$toast.error(`Hubo un problema al consultar los balances del período seleccionado: ${error.message}`);
                    this.showBalancesDialog = false;
                } finally {
                    this.balancesLoading = false;
                }
            },
            reopenPeriodFromBalancesDialog() {
                if (!this.selectedBalancesPeriod || this.periodActionsLocked) {
                    return;
                }

                this.hideClosingJobStatusOnInteraction();
                this.selectedPeriod = this.selectedBalancesPeriod;
                this.form.month = this.selectedBalancesPeriod.month;
                this.form.year = this.selectedBalancesPeriod.year;
                this.form.pwd = "";
                this.showBalancesDialog = false;
                this.closeConfirmDialog = false;
                this.showReopenDialog = false;
                this.reopenConfirmDialog = true;
            },
            async closePeriodOperations() {
                if (this.closingJobRunning) {
                    return;
                }

                this.hideClosingJobStatusOnInteraction();
                this.loading = true;
                this.closeConfirmDialog = false;
                this.prepareClosingJobTracking();

                try {
                    const response = await this.$API.accountingperiod.modifyAccountingPeriod({
                        month: this.form.month,
                        year: this.form.year,
                        is_closed: 1
                    });

                    const normalizedState = this.normalizeClosingJobState(response);

                    this.closingJobStatus = {
                        ...this.closingJobStatus,
                        ...normalizedState
                    };
                    this.closingJobJobId = this.closingJobStatus.jobId || this.closingJobJobId;

                    if (this.isClosingJobFailed(this.closingJobStatus)) {
                        this.finishClosingJobTracking();
                        this.$toasted.error(this.getClosingJobErrorMessage(this.closingJobStatus, "El cierre contable no pudo completarse."));
                        return;
                    }

                    if (this.isClosingJobCompleted(this.closingJobStatus)) {
                        await this.refreshClosedPeriodAfterCompletion();
                        this.finishClosingJobTracking();
                        this.$toasted.success(this.closingJobStatus.message || "Se cerraron las operaciones del período seleccionado.");
                        return;
                    }

                    if (!this.closingJobJobId) {
                        this.clearClosingJobTracking();
                        this.$toasted.error("No se recibió el identificador del job de cierre.");
                        return;
                    }

                    this.scheduleClosingJobPoll();
                } catch (error) {
                    this.clearClosingJobTracking();
                    this.$toasted.error(`Hubo un problema al intentar cerrar las operaciones del período seleccionado: ${this.getClosingJobErrorMessage(error, "Error desconocido")}`);
                } finally {
                    this.loading = false;
                }
            },
            async reopenMonthOperations() {
                this.hideClosingJobStatusOnInteraction();
                this.loading = true;
                this.reopenPeriodRunning = true;

                try {
                    this.showReopenDialog = false;

                    await this.$API.auth.specialAccess({ password: this.form.pwd });

                    await this.$API.accountingperiod.modifyAccountingPeriod({
                        month: this.form.month,
                        year: this.form.year,
                        is_closed: 0
                    });

                    this.periods = this.periods.map((period) => {
                        if (
                            Number(period.month) !== Number(this.form.month) ||
                            Number(period.year) !== Number(this.form.year)
                        ) {
                            return period;
                        }

                        return {
                            ...period,
                            is_closed: 0,
                            IsClosedText: "Abierto",
                            closing_date: null,
                            ClosingBalanceActivosYEgresos: null,
                            ClosingBalancePasivosEIngresos: null,
                            ClosingBalancesCountActivosYEgresos: null,
                            ClosingBalancesCountPasivosEIngresos: null,
                        };
                    });

                    this.$toasted.success("Se reaperturaron las operaciones del período seleccionado.");
                } catch (error) {
                    this.$toasted.error(`Hubo un problema al intentar reaperturar el período seleccionado: ${error.message}`);
                } finally {
                    this.loading = false;
                    this.reopenPeriodRunning = false;
                    this.form.pwd = "";
                }
            },
            filterHandler( { result } ) {
                this.periods = [ ...result ];
            },
        }
    }
</script>

<style lang="scss" scoped>
.cancel {
    background-color: #41464c !important;
    color: white;
}

.closing-balance-money-cell {
    display: block;
    width: 100%;
    text-align: right !important;
    white-space: nowrap;
}

.account-code-left-cell {
    display: block;
    width: 100%;
    overflow: hidden;
    text-align: left !important;
    text-overflow: ellipsis;
    white-space: nowrap;
}
</style>
